import React from "react";
import PropTypes from 'prop-types';
import { JobItem } from "./JobItem";
import { Loader } from "../../../../common/elements";
import { JobsMpu } from "../../../../common/adverts/googleDFP/JobsMpu";
import { uuid } from '../../../../../helpers/';
import { siteOfOriginHelper } from '../../../../../../client/helpers/genericHelpers';

export const JobList = (props) => {
    const siteOfOrigin = siteOfOriginHelper();

    if (props.jobs && props.jobs.length > 0) {
        return (
            <div className="jobs-list">
                <div className="row top-of-list job__card-list">
                    {props.jobs.map((job, index) =>
                        props.jobs[index].id ? (
                            <JobItem key={ uuid() }
                                     addJobToFavourites={props.addJobToFavourites}
                                     removeJobFromFavourites={props.removeJobFromFavourites}
                                     index={props.index}
                                     job={props.jobs[index]}
                                     industries={props.industries}
                                     locations={props.locations}
                            />
                        ) : ( siteOfOrigin !== 'us' && <JobsMpu key={index}/> )
                            )}
                </div>
            </div>
        );
    } else {
        return <Loader/>;
    }
};

JobList.propTypes = {
  jobs: PropTypes.any,
  removeJobFromFavourites: PropTypes.func,
  addJobToFavourites: PropTypes.func,
  locations: PropTypes.array,
  industries: PropTypes.array,
};



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/JobList.js